module.exports = __webpack_public_path__ + "static/vilano.resized-0ae27cd07701cab246375b5f0dddbc3a.jpg";